const branding = {
  header: 'Cabeçalho',
  backgroundColor: 'Cor de fundo',
  textColor: 'Cor do texto',
  button: 'Botão',
};

export default branding;
